export function handleProductClick({ evt, product }) {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    let canonicalUrl = product?.identifiers?.canonicalUrl;
    if (canonicalUrl && !(evt.ctrlKey || evt.metaKey)) {
      evt.preventDefault();
      window.LIFE_CYCLE_EVENT_BUS.trigger('fusion-navigate.change', {
        path: canonicalUrl
      });
    }
  }
}

const hasDeliveryFilter = (breadCrumbs, filterLabelList) => {
  return (breadCrumbs || []).filter((breadCrumbDetail) => filterLabelList.includes(breadCrumbDetail?.label));
};

export function hasSameDayFilter(breadCrumbs) {
  const applicableFilters = ['Same-Day Delivery', 'Next-Day Delivery'];
  return !!hasDeliveryFilter(breadCrumbs, applicableFilters).length;
}

export function onPageChange({ url, resultsRef }) {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    const offsetTop = resultsRef?.current?.parentElement?.parentElement?.offsetTop || 0;
    window.LIFE_CYCLE_EVENT_BUS.trigger('fusion-navigate.change', {
      path: url,
      disableScroll: false,
      replace: false,
      scrollPosition: offsetTop
    });
  }
}
export const impProductPodData = (layoutID) => {
  return {
    id: layoutID || '',
    component: 'ResultsWrapped',
    name: 'ProductListing',
    type: 'product'
  };
};

export const getPageTypeFromPath = (pathname = '') => {
  const normalizedPath = pathname.toLowerCase().replace(/^\/render[^/]*/, '');
  if (normalizedPath.includes('/b/')) {
    return 'browse';
  }
  if (normalizedPath.includes('/s/')) {
    return 'search';
  }
  return null;
};

export const stringifyItemIds = (hookData) => {
  return hookData?.searchModel?.products?.map(({ itemId: sku }) => sku).join('-');
};

export const stringifyAppliedRefinements = (hookData) => {
  const appliedDimensions = hookData?.searchModel?.appliedDimensions || [];
  return appliedDimensions
    .map(({ refinements = [] }) => {
      return refinements.map((refinement) => refinement.refinementKey).join('-');
    })
    .join('-');
};

export const isNIncluded = (value) => {
  return value?.includes('N-');
};